module.exports = __webpack_public_path__ + "img/yang_sheng_hao__0.065d9df6.jpg";